import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "align", "spacing"];
import { Flex } from '../../../components/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
const spacingToToken = {
  none: '0',
  'extra-small': '200',
  small: '300',
  medium: '400',
  large: '500',
  'extra-large': '600'
};
export const Media = _ref => {
  let {
      children,
      align,
      spacing = 'small'
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Flex, Object.assign({
    alignItems: align,
    flexDirection: "row",
    inlineSize: "100%",
    columnGap: spacingToToken[spacing]
  }, rest, {
    children: children
  }));
};